var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "list_svg__nc-icon-wrapper",
    strokeLinecap: "square",
    strokeWidth: 2,
    fill: "none",
    stroke: "#86AE43",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 2h50v60H7z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M31 18h16M16 18l2 2 6-6M31 32h16M16 32l2 2 6-6M31 46h16"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    cx: 19,
    cy: 46,
    r: 3
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+PGcgY2xhc3M9Im5jLWljb24td3JhcHBlciIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLWxpbmVqb2luPSJtaXRlciIgc3Ryb2tlLXdpZHRoPSIyIiBmaWxsPSIjODZBRTQzIiBzdHJva2U9IiM4NkFFNDMiPjxyZWN0IHg9IjciIHk9IjIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzg2QUU0MyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiB3aWR0aD0iNTAiIGhlaWdodD0iNjAiLz4gPGxpbmUgZGF0YS1jb2xvcj0iY29sb3ItMiIgZmlsbD0ibm9uZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiB4MT0iMzEiIHkxPSIxOCIgeDI9IjQ3IiB5Mj0iMTgiLz4gPHBvbHlsaW5lIGRhdGEtY29sb3I9ImNvbG9yLTIiIGZpbGw9Im5vbmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgcG9pbnRzPSIgMTYsMTggMTgsMjAgMjQsMTQgIi8+IDxsaW5lIGRhdGEtY29sb3I9ImNvbG9yLTIiIGZpbGw9Im5vbmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgeDE9IjMxIiB5MT0iMzIiIHgyPSI0NyIgeTI9IjMyIi8+IDxwb2x5bGluZSBkYXRhLWNvbG9yPSJjb2xvci0yIiBmaWxsPSJub25lIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHBvaW50cz0iIDE2LDMyIDE4LDM0IDI0LDI4ICIvPiA8bGluZSBkYXRhLWNvbG9yPSJjb2xvci0yIiBmaWxsPSJub25lIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHgxPSIzMSIgeTE9IjQ2IiB4Mj0iNDciIHkyPSI0NiIvPiA8Y2lyY2xlIGRhdGEtY29sb3I9ImNvbG9yLTIiIGZpbGw9Im5vbmUiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgY3g9IjE5IiBjeT0iNDYiIHI9IjMiLz48L2c+PC9zdmc+";
export { SvgList as ReactComponent };